
import { motion } from "framer-motion";
import { ZapIcon, BrainIcon, PaintbrushIcon, LockIcon } from "lucide-react";
import ParticleBackground from "@/components/ParticleBackground";
import NewsletterForm from "@/components/NewsletterForm";

const Index = () => {
  return (
    <div className="min-h-screen relative">
      <ParticleBackground />
      
      {/* Hero Section */}
      <motion.header 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="pt-20 pb-16 px-4"
      >
        <h1 className="text-4xl md:text-6xl font-bold tracking-tighter mb-6">
          Hollow Arc Ventures
        </h1>
        <p className="text-muted-foreground text-lg mb-8">LLC</p>
      </motion.header>

      {/* Mission Section */}
      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="max-w-2xl mx-auto px-4 py-12"
      >
        <p className="text-xl md:text-2xl font-light leading-relaxed text-center">
          Operating in the liminal spaces between technology and possibility.
          Crafting tomorrow's solutions in today's shadows.
        </p>
      </motion.section>

      {/* Areas of Focus */}
      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="py-16 px-4"
      >
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="focus-area">
            <BrainIcon className="w-8 h-8 mb-4 text-[#BFA181]" />
            <h3 className="text-xl font-bold mb-2">Artificial Intelligence</h3>
            <p className="text-muted-foreground">Pushing the boundaries of machine cognition</p>
          </div>
          <div className="focus-area">
            <PaintbrushIcon className="w-8 h-8 mb-4 text-[#0047AB]" />
            <h3 className="text-xl font-bold mb-2">Creative Technology</h3>
            <p className="text-muted-foreground">Where innovation meets expression</p>
          </div>
          <div className="focus-area">
            <LockIcon className="w-8 h-8 mb-4 text-[#BFA181]" />
            <h3 className="text-xl font-bold mb-2">Privacy Tools</h3>
            <p className="text-muted-foreground">Securing digital autonomy</p>
          </div>
        </div>
      </motion.section>

      {/* Tagline Section */}
      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="py-16 px-4 bg-muted"
      >
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-bold tracking-tight">
            We Back Ideas That Bend the Curve
          </h2>
        </div>
      </motion.section>

      {/* Newsletter Section */}
      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="py-16 px-4"
      >
        <div className="max-w-2xl mx-auto text-center">
          <h3 className="text-xl font-bold mb-6">Join the waiting list</h3>
          <p className="text-muted-foreground mb-8">Stay informed about our future revelations</p>
          <NewsletterForm />
        </div>
      </motion.section>
    </div>
  );
};

export default Index;
